module.exports = __webpack_public_path__ + "static/media/krill.a05556b0.jpg";